module.exports = __webpack_public_path__ + "img/_Small-Horizontal-Rectangular-Attachment.28b5a41f.jpg";